const FinanceTabSkeleton = () => (
  <div
    className="bg-white rounded-3xl border border-slate-200/90 shadow-sm p-6 lg:p-8 w-full animate-pulse"
    aria-busy="true"
    aria-live="polite"
  >
    <span className="sr-only">Memuat data keuangan...</span>

    <div className="flex flex-col md:flex-row justify-between md:items-center mb-8 gap-4 border-b border-slate-100 pb-6">
      <div className="space-y-3">
        <div className="h-6 w-64 rounded-xl bg-slate-200" />
        <div className="h-4 w-80 max-w-full rounded-lg bg-slate-100" />
      </div>
      <div className="md:text-right bg-slate-50 p-4 rounded-xl border border-slate-200">
        <div className="h-3 w-32 rounded bg-slate-200 mb-2" />
        <div className="h-8 w-40 rounded-lg bg-slate-200" />
      </div>
    </div>

    <div className="space-y-4">
      {[0, 1, 2].map((key) => (
        <div
          key={key}
          className="border border-slate-200 rounded-2xl overflow-hidden relative bg-white"
        >
          <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-slate-200" />
          <div className="p-5 flex flex-col md:flex-row md:items-center justify-between gap-6 pl-7">
            <div className="flex gap-5 items-center">
              <div className="w-14 h-14 rounded-full bg-slate-100 border border-slate-200 shrink-0" />
              <div className="space-y-2">
                <div className="h-5 w-40 rounded-lg bg-slate-200" />
                <div className="flex items-center gap-3">
                  <div className="h-4 w-28 rounded bg-slate-100" />
                  <div className="h-4 w-12 rounded-md bg-slate-100" />
                </div>
              </div>
            </div>
            <div className="flex flex-col items-start md:items-end gap-2">
              <div className="h-8 w-36 rounded-lg bg-slate-200" />
              <div className="h-10 w-40 rounded-xl bg-slate-100" />
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default FinanceTabSkeleton;
